import { HOPE_ORG_NAME, HOPE_ORG_FULL } from "../data/brand";

export default function HopeNamingNote({ className = "" }) {
    return (
        <p
            data-testid="hope-naming-explainer"
            className={`text-sm leading-relaxed ${className}`}
        >
            Hope is named after <span className="font-semibold">{HOPE_ORG_NAME}</span> —{" "}
            {HOPE_ORG_FULL} — the team built around this work.
        </p>
    );
}
